export default __webpack_public_path__ + "static/media/discord.0569e256.png";